var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0013V97.9987C19.9997 98.8884 20.2369 99.7619 20.6869 100.529C21.1369 101.297 21.7835 101.93 22.56 102.364C23.3366 102.798 24.2148 103.017 25.1043 102.999C25.9937 102.98 26.8621 102.725 27.6198 102.259L92.6177 62.2599C93.3457 61.8125 93.9469 61.1861 94.3639 60.4404C94.781 59.6946 94.9999 58.8544 94.9999 58C94.9999 57.1456 94.781 56.3054 94.3639 55.5596C93.9469 54.8139 93.3457 54.1875 92.6177 53.7401L27.6198 13.7414C26.8621 13.2752 25.9937 13.0197 25.1043 13.0011C24.2148 12.9825 23.3366 13.2016 22.56 13.6357C21.7835 14.0698 21.1369 14.7032 20.6869 15.4706C20.2369 16.2381 19.9997 17.1116 20 18.0013Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.e854e7c559a0f3a1158704a20a59742f.svg";
export { ForwardRef as ReactComponent };